import { memo, useEffect, useState } from "react";
import { RiCalendarScheduleLine } from "react-icons/ri";
// import { Handle, Position } from "reactflow";
import { useNodeContext } from "../../../../context/NodeContext";
import BASE_URL from "../../../../../config";
import { MdDeleteOutline } from "react-icons/md";
import { Handle, Position } from "@xyflow/react";
import CustomHandle from "../custome_handle/CustomHandle";

function SchedulerShape({ id, data, isConnectable }) {
  const { setShowShapeUpdateForm, shapeId, setShapeId, handleNodeDelete } =
    useNodeContext();
  const [isDelBtn, setDelBtn] = useState(false);

  // useEffect for shoeing del button not active
  useEffect(() => {
    if (id === shapeId) {
      setDelBtn(true);
    } else {
      setDelBtn(false);
    }
  }, [shapeId]);

  const handleClick = async (e) => {
    e.stopPropagation();
    setDelBtn(!isDelBtn);
    setShowShapeUpdateForm(true);
    setShapeId(id);
  };
  return (
    <div className="" onClick={handleClick}>
      <Handle
        type="target"
        position={Position.Left}
        style={{ top: "50%", left: "0px", zIndex: "10" }}
        isConnectable={isConnectable}
        // connectionCount={1}
      />
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "0px",
        }}
      >
        <RiCalendarScheduleLine style={{ fontSize: "35px" }} />
        <span
          style={{
            position: "absolute",
            fontSize: "8px",
            bottom: "-10px",
            width: "max-content",
          }}
        >
          {data.value}
        </span>
        {isDelBtn && (
          <button
            style={{ top: "-7px", right: "-10px" }}
            className="btn pm_shape_del_btn"
            onClick={handleNodeDelete}
          >
            <MdDeleteOutline />
          </button>
        )}
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        style={{ top: "50%" }}
        isConnectable={isConnectable}
        // connectionCount={1}
      />
    </div>
  );
}

export default memo(SchedulerShape);
